import { actions } from '@sloyd/store-base';
import { put } from 'saga-ts';

export function* playKeyframeHud(keyframe: IKeyframe) {
  yield put(actions.animationState.patch({ showHud: true }));
}
